import { useState } from "react";
// import { Col } from "reactstrap";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Nav, NavItem } from "reactstrap";
import { SidebarLinks } from "./SidebarLinks";
import Logo from "../../../assets/images/logo.jpeg";
/**
 * Sidebar Component for the app
 *
 * @returns {JSX.Element}
 */
export default function Sidebar() {
  const sidebarMenu = SidebarLinks;
  const location = useLocation();

  const [openDropdownId, setOpenDropdownId] = useState(null);

  const toggleDropdown = (dropdownId: any) => {
    if (openDropdownId === dropdownId) {
      setOpenDropdownId(null);
    } else {
      setOpenDropdownId(dropdownId);
    }
  };

  const renderSidebarItem = (item: any) => {
    const { id, menuName, menuIcon, path, children } = item;
    if (children) {
      const isDropdownOpen = openDropdownId === id;
      const dropdownClass = isDropdownOpen ? "show" : "";

      const isChildActive = children.some((child: any) => location.pathname.startsWith(child.path));

      return (
        <NavItem as='li' key={id}>
          <NavItem
            className={`align-items-center d-flex fw-medium nav-link px-0 sidebarLink text-nowrap ${
              isChildActive ? "active" : ""
            }`}
            onClick={() => toggleDropdown(id)}
            aria-expanded={isDropdownOpen ? "true" : "false"}
          >
            <span className='mx-1 py-1 text-center px-3 sidebarIcon'>{menuIcon}</span> {menuName}
          </NavItem>

          <Nav as='ul' id={`submenu-${id}`} className={`flex-column collapse ${dropdownClass}`}>
            {children.map((child: any) => {
              const {
                id: childId,
                menuName: childMenuName,
                menuIcon: childMenuIcon,
                path: childPath,
              } = child;

              return (
                <NavItem as='li' key={childId} className='ms-3'>
                  <NavLink
                    to={childPath}
                    className='align-items-center d-flex fw-medium nav-link px-0 sidebarLink text-nowrap'
                  >
                    <span className='mx-1 py-1 text-center px-3 sidebarIcon'>{childMenuIcon}</span>{" "}
                    {childMenuName}
                  </NavLink>
                </NavItem>
              );
            })}
          </Nav>
        </NavItem>
      );
    } else {
      return (
        <NavItem as='li' key={id}>
          <NavLink
            to={path}
            className='align-items-center d-flex fw-medium nav-link px-0 sidebarLink text-nowrap'
          >
            <span className='mx-1 py-1 text-center px-3 sidebarIcon'>{menuIcon}</span> {menuName}
          </NavLink>
        </NavItem>
      );
    }
  };

  return (
    <div className='sidebarMenu h-100'>
      <aside className='h-100 bg-white'>
        <div className='d-flex flex-column h-100'>
          <div className='align-items-center d-flex justify-content-center p-2 sidebarLogo text-center'>
            <Link to='/' className='d-inline-block py-1 m-4'>
              <img src={Logo} alt='Logo' className='img-fluid' width={160} />
            </Link>
          </div>
          <div className='d-flex flex-column justify-content-between h-100'>
            <div className='overflow-auto sidebarList'>
              <Nav defaultActiveKey='/dashboard' as='ul' className='flex-column'>
                {sidebarMenu.map((elem) => renderSidebarItem(elem))}
              </Nav>
            </div>
            {/* <div className='d-flex flex-column'>
              <span className='text-center'>
                Backend: <strong>{"backendVersion"}</strong>
              </span>
              <span className='text-center'>
                Frontend: <strong>{packageJson.version}</strong>
              </span>
            </div> */}
          </div>
        </div>
      </aside>
    </div>
  );
}
